export const getParticipantsCount = (date: Date | undefined) => {
    const rnd = (seed: number) => {
        const x = Math.sin(seed) * 10000;
        return x - Math.floor(x);
    };
    const dateDay = (d: Date) => {
        return Math.ceil(d.valueOf() / 1000 / 60 / 60 / 24);
    };
    const firstDay = dateDay(new Date('2015-01-01T00:00:00Z'));
    const lastDay = dateDay(date || new Date());
    let value = 0;
    for (let i = firstDay; i <= lastDay; i += 1) {
        value += Math.round(rnd(i) * 240);
    }
    return value;
};
